import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'

interface DataTableFilterSelectorProps {
	options: readonly {
		readonly label: string
		readonly value: string
	}[]
	placeholder?: string
	label?: string
	onValueChange: (value: string) => void
}

export function DataTableFilterSelector({
	options,
	placeholder,
	label,
	onValueChange,
}: DataTableFilterSelectorProps) {
	const allOptions = [{ label: 'ทั้งหมด', value: '' }, ...options]

	return (
		<div className="flex space-x-2">
			<Select onValueChange={onValueChange}>
				<SelectTrigger className="w-[180px]">
					<SelectValue placeholder={placeholder} />
				</SelectTrigger>
				<SelectContent>
					<SelectGroup>
						{label && <SelectLabel>{label}</SelectLabel>}
						{allOptions.map((option) => (
							<SelectItem key={option.value} value={option.value}>
								{option.label}
							</SelectItem>
						))}
					</SelectGroup>
				</SelectContent>
			</Select>
		</div>
	)
}
